export class Inputs {
	get(): string {
		return 'test';
	}
}
